import React, { useEffect } from 'react';

import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { RootState } from '../store/indexRedux';
import LoginForm from '../components/auth/LoginForm';

const Login: React.FC = () => {
  const { t } = useTranslation('Login');

  const navigate = useNavigate();
  const isAuthenticated = useSelector((state: RootState) => state.auth.isAuthenticated);

  useEffect(() => {
    if (isAuthenticated) {
      navigate('/');
    }
  }, [isAuthenticated, navigate]);

  return (
    <div className='text-primary flex flex-col gap-20 lg:gap-0 items-center justify-center lg:flex-row w-[80%] m-auto '>
      <div className='flex mt-10 lg:mt-0 gap-5 flex-col  justify-center w-4/6  lg:w-[50%] '>
        <h1 className='text-left lg:text-3xl'>
          <span className='font-bold'>{t('welcome')}</span> <br /> {t('sign_in')}
        </h1>

        <div>
          <LoginForm />
        </div>
      </div>
      <div className='w-auto lg:w-[50%] round'>
        <img className='rounded-md' src='https://my.yuso.io/solar-wind.jpg' alt={t('alt_text')} />
      </div>
    </div>
  );
};

export default Login;
